var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('modal-box-error'),_c('modal-box-timeout-warning'),_c('app-header'),_c('router-view',{staticClass:"row",attrs:{"id":"page-content"}}),_c('cookie-notification',{attrs:{"redirect-uri":"/ekpid"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }